import {WF_ENDPOINT} from "../utils/constants";
import {Feature, hasFeature} from "../utils/features";
import {BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError} from "@reduxjs/toolkit/query/react";
import {GetTokenSilentlyOptions} from "@auth0/auth0-react";
import {currentLocation, navigate} from "../utils/router.tsx";
import {parse} from "qs";
import {createURLSearchParams} from "../utils/commons.ts";

// export class FetchError extends Error {
//     readonly response: QueryReturnValue;
//
//     constructor(message: string, response: QueryReturnValue) {
//         super(message);
//         this.name = "FetchError";
//         this.response = response;
//     }
// }

// export async function apiCall({urlComponent, method = HttpMethod.GET, contentType = "application/json", query, body, ignoreAuthResponse = false}: ApiCallParams): Promise<Response> {
//     const location = routerTools.location;
//
//     const locationQP = parse(location.search, {ignoreQueryPrefix: true});
//
//     if (locationQP && locationQP.ticket) {
//         query = query || {};
//         (query as Record<string, string>).ticket = locationQP.ticket as string;
//     }
//
//     if (!urlComponent.startsWith("/") && !(urlComponent.startsWith("http://") || urlComponent.startsWith("https://"))) {
//         urlComponent = "/" + urlComponent;
//     }
//
//     let url = (urlComponent.startsWith("http://") || urlComponent.startsWith("https://")) ? urlComponent : `${WF_ENDPOINT}${urlComponent}`;
//
//     if (query) {
//         url = url + `?${createURLSearchParams(query as Record<string, string>).toString()}`;
//     }
//
//     const headers: {[key: string]: string} = {
//         "Content-Type": contentType,
//     };
//
//     if (hasFeature(Feature.AUTH0)) {
//         try {
//             const token = await getToken();
//             if (token) {
//                 headers["Authorization"] = `Bearer ${token}`;
//             }
//         } catch (err) {
//             console.log(err);
//         }
//     }
//
//     const fetchOps: RequestInit = {
//         method,
//         headers,
//         credentials: "include",
//     };
//
//     if (body) {
//         fetchOps.body = JSON.stringify(body);
//     }
//
//     const res = await fetch(url, fetchOps);
//
//     if (!res.ok) {
//         if (res.status === 401 && !ignoreAuthResponse) {
//             store.dispatch(setUserInfo(undefined));
//             if (hasFeature(Feature.AUTH0)) {
//                 routerTools.replace("/");
//             } else {
//                 routerTools.replace("/login");
//             }
//         }
//         throw new FetchError("There was an error while fetching", res);
//     } else {
//         return res;
//     }
// }

export async function getApiUrl({urlComponent, query}: {urlComponent: string, query?: Record<string, string>}): Promise<string> {
    if (!urlComponent.startsWith("/")) {
        urlComponent = "/" + urlComponent;
    }

    let url = `${WF_ENDPOINT}${urlComponent}`;

    if (!query) {
        query = {};
    }

    if (hasFeature(Feature.AUTH0)) {
        try {
            const token = await getToken();
            if (token) {
                query.token = token as string;
            }
        } catch  {
            /* noop */
        }
    }

    if (query) {
        url = url + `?${createURLSearchParams(query).toString()}`;
    }

    return url;
}

export let getToken: (options?: GetTokenSilentlyOptions) => Promise<string>;
export function initGetTokenFunction(func: (options?: GetTokenSilentlyOptions) => Promise<string>) {
    getToken = func;
}

export enum HttpMethod {
    GET = "GET",
    POST = "POST",
    PUT = "PUT",
    PATCH = "PATCH",
    DELETE = "DELETE",
    HEAD = "HEAD",
}

export function authenticatedFetchBaseQuery(endpoint?: string, ignoreAuthResponse: boolean = false, contentType: string = "application/json"): BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
> {
    const baseQuery = fetchBaseQuery({
        baseUrl: endpoint || WF_ENDPOINT,
        prepareHeaders: async (headers) => {
            headers.set("Accept", contentType);
            headers.set("Content-Type", contentType);
            if (hasFeature(Feature.AUTH0)) {
                try {
                    const token = await getToken();
                    if (token) {
                        headers.set("Authorization", `Bearer ${token}`);
                    }
                } catch (err) {
                    console.log(err);
                }
            }
            return headers;
        },
        credentials: 'include',
        mode: 'cors',
    });

    return async (args, api, extraOptions) => {
        const locatonQP = parse(currentLocation.search, {ignoreQueryPrefix: true});
        if (locatonQP && locatonQP.ticket) {
            const url = typeof args === "string" ? args : args.url;
            const newUrl = `${url}${url.includes("?") ? "&" : "?"}ticket=${locatonQP.ticket}`;
            args = typeof args === "string" ? newUrl : { ...args, url: newUrl };
        }
        // TODO: see what arrives here while debugging and add the ticket if needed according to the location
        const result = await baseQuery(args, api, extraOptions);
        if (result.error && result.error.status === 401 && !ignoreAuthResponse) {
            // TODO: clear user info in the store maybe use api
            if (hasFeature(Feature.AUTH0)) {
                navigate("/", {replace: true});
            } else {
                navigate("/login", {replace: true});
            }
        }
        return result;
    };
}
